<template>
    <section class="products-banner-wrap">
        <b-img src="@/assets/images/products_page/banner.jpg" fluid alt="wipe clear explore more"></b-img>
        <b-container class="sbanner-wrap">
            <b-row>
                <b-col
                    class="sbanner-item position-relative"
                    v-for="(sbanner, i) in sBanners" :key="i"
                >
                    <b-img :src="sbanner.src" fluid></b-img>
                    <h3>{{sbanner.title}}</h3>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            sBanners: [
                {
                    src: require('@/assets/images/products_page/sbanner_01.jpg'),
                    title: 'INNOVATIVE'
                },
                {
                    src: require('@/assets/images/products_page/sbanner_02.jpg'),
                    title: 'RELIABLE'
                },
                {
                    src: require('@/assets/images/products_page/sbanner_03.jpg'),
                    title: 'EFFICIENT'
                }
            ]      
        }
    },
}
</script>

<style lang="scss">
    .products-banner-wrap{
        position: relative;
        padding-bottom: 10%;
    }
    .sbanner{
        &-wrap{
            position: absolute;
            left: 0;
            right: 0;
            bottom: 5%;
        }
        
        &-item{
            position: relative;

            h3 {
                margin-bottom: 0;
                position: absolute;
                bottom: 0;
                left: 15px;
                right: 15px;
                color: rgba(255,255,255,1);
                line-height: 2;
                font-size: 20px;
                font-weight: bold;
                text-align: center;
                letter-spacing: 2px;
                background-color: rgba(21,110,172,0.8);
            }
        }
    }
    
</style>